import {queryIncCustomList} from '@api/incubator/custom';

// 孵化器客户列表迁入、迁出
const INCU_CUSTOM_LIST = 'INCU_CUSTOM_LIST';
const INCU_CUSTOM_LIST_RESET = 'INCU_CUSTOM_LIST_RESET';
const INCU_CUSTOM_TAB = 'INCU_CUSTOM_TAB';
const INCU_CUSTOM_LIST_LOADING = 'INCU_CUSTOM_LIST_LOADING';
const INCU_CUSTOM_LIST_SUCCESS = 'INCU_CUSTOM_LIST_SUCCESS';
const initState = {
  residentCustomerDataSource: {
    params: {},
    list: [],
    pagination: {},
  },
  incubatingCustomerDataSource: {
    params: {},
    list: [],
    pagination: {},
  },
  condition: {},
};

export function changeTab(tab) {
  return (dispatch, getState) => {
    dispatch({
      type: INCU_CUSTOM_TAB,
      data: {
        tab,
      },
    });
  };
}

export function getIncCustomList(params) {
  return (dispatch, getState) => {
    const loading = {};
    loading[`${params.tab}Loading`] = true;
    dispatch({
      type: INCU_CUSTOM_LIST_LOADING,
      data: {
        ...loading,
      },
    });
    return queryIncCustomList(params).then(res => {
      if (res.statusCode === 200) {
        loading[`${params.tab}Loading`] = false;
        dispatch({
          type: INCU_CUSTOM_LIST_SUCCESS,
          data: {
            ...loading,
          },
        });
        const data = {};
        data[`${params.tab}DataSource`] = {
          params,
          list: res.data,
          pagination: {
            total: res.totalSize,
            pageSize: params.limit,
            current: params.current || 1,
            pageSizeOptions: [10, 20, 50, 100],
            showSizeChanger: true,
            showQuickJumper: true,
          },
        };
        const condition = {};
        condition[`${params.tab}Current`] = params.current;
        condition[`${params.tab}PageSize`] = params.limit;
        return dispatch({
          type: INCU_CUSTOM_LIST,
          data: {
            ...data,
            condition: {
              ...condition,
              condition: params.condition,
              incubatorUuid: params.incubatorUuid,
            },
          },
        });
      }
    });
  };
}

export function reset() {
  return dispatch => {
    dispatch({
      type: INCU_CUSTOM_LIST_RESET,
      data: initState,
    });
  };
}

export function incuCustomList(state = initState, action) {
  switch (action.type) {
    case INCU_CUSTOM_TAB:
      return { ...state, ...action.data };
    case INCU_CUSTOM_LIST:
      return { ...state, ...action.data };
    case INCU_CUSTOM_LIST_SUCCESS:
      return { ...state, ...action.data };
    case INCU_CUSTOM_LIST_LOADING:
      return { ...state, ...action.data };
    case INCU_CUSTOM_LIST_RESET:
      return { ...state, ...action.data };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/incubator/incu_custom_list.js